<div *ngIf="invite" class="text-center">
  <div class="site-font text-lg mb-2">Invited to help out with</div>
  <div class="site-font text-4xl">{{ invite.organization.name }}</div>

  <div class="mt-4">
    <p-button [label]="accepting ? 'Accepting...' : 'Accept invite'" size="large" type="submit" icon="bi bi-box-arrow-in-right" severity="primary"
      fluid="true" [disabled]="accepting" (onClick)="acceptInvite()"></p-button>
  </div>
</div>

<div *ngIf="!invite">

  <div class="site-font text-2xl text-center mb-3">Invite Code</div>

  <p-message severity="warn" class="mb-4">
    This invite code has expired or does not exist anymore. Contact whoever shared it with you to get a new one.
  </p-message>
</div>